import { getParent, types } from 'mobx-state-tree';
import { model, Model, view } from 'mst-collection';

import { TariffPlanPriceModel } from './TariffPlanPriceModel';
import type { TariffPlans } from './TariffPlansModel';

export class TariffPlan extends Model({
  price: types.optional(TariffPlanPriceModel, {}),
  code: types.number,
  upgradeCode: types.maybeNull(types.number),
  benefits: types.array(types.string),
}) {
  private get _parentPlans(): TariffPlans {
    return getParent<TariffPlans>(this, 2);
  }

  get autoupgradePlan(): TariffPlan | undefined {
    if (!this.upgradeCode) {
      return;
    }

    return this._parentPlans.byCode[this.upgradeCode];
  }

  @view
  save(fromCode: number): string | null {
    const saveAmount = this._parentPlans.save.find(
      (s) => s.fromCode === fromCode && s.toCode === this.code,
    )?.formattedValue;

    if (!saveAmount) {
      return null;
    }

    return saveAmount;
  }
}

export const TariffPlanModel = model(TariffPlan);
